export function formatInvoiceNumber(num: number | string): string {
  return `#${num.toString().padStart(6, '0')}`;
}

export function isPastDue(date: Date): boolean {
  return date.getTime() < new Date().getTime();
}
